// extracted by mini-css-extract-plugin
export default {"tellustabs":"TellUsTabs_tellustabs__70jlj"};